module.exports = __webpack_public_path__ + "img/cs-title-icon.a93fe7fe.png";